// libs
import React, { memo, useMemo } from 'react';

// global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';

// components
import MobileCAV from './Mobile';
import DesktopCAV from './Desktop';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// styles
import { WidgetWrapper, WidgetContainer, WidgetHeader } from './styles';

// constants
import { BREAKPOINTS } from 'shared/styles/base';
import { CAV_DWEB_CONSTANTS } from './constants';

// defs
import { IWidgetData } from 'shared/layouts/DetailsPage/components/Widgets/types';

interface IRenderCAV {
  widget: IWidgetData;
  i: number;
  ppid: number;
}

function RenderCAV({ widget, i, ppid }: IRenderCAV) {
  const { deviceWidth } = useResponsiveContext();

  const cavData = useMemo(() => {
    const cavTrackingURLs = (widget?.categories || []).map((item) => {
      const actionURL = `${item.action_url}?intcmp=widget,cav&ppid=${ppid}`;
      return { ...item, action_url: actionURL };
    });

    return {
      ...widget,
      categories: cavTrackingURLs,
    };
  }, [ppid, widget]);

  if (
    !widget.categories ||
    (deviceWidth > BREAKPOINTS.DESKTOP &&
      widget.categories.length < CAV_DWEB_CONSTANTS.minimumWidgetCount)
  ) {
    return null;
  }

  const products = cavData.categories;
  const actionUrl = cavData.action_url;
  const widgetMetaData = { widgetTitle: cavData?.title, widgetType: cavData?.widget_type };

  return (
    <WidgetWrapper id={`widget_${i}`}>
      <WidgetContainer>
        <WidgetHeader>{widget.title}</WidgetHeader>
        <RouteChunkRenderer
          desktopComponent={<DesktopCAV products={products} widgetMetaData={widgetMetaData} />}
          mobileComponent={
            <MobileCAV products={products} actionUrl={actionUrl} widgetMetaData={widgetMetaData} />
          }
        />
      </WidgetContainer>
    </WidgetWrapper>
  );
}

export default memo(RenderCAV);
